import PinInput from 'react-pin-input';

type PinEntryProps = {
  onChangePin: (pin: string) => void;
};

export const PinEntry = ({onChangePin}: PinEntryProps) => {
  return (
    <PinInput
      focus
      initialValue=""
      type="numeric"
      secret
      length={6}
      onChange={onChangePin}
    />
  );
};
